import { Page } from "@/models/page-models/Page";

export const GoodsEditor: Page = {
  "path": "goodsEditor",
  "name": "Goods Editor",
  "props": {
    "data": {
      "title": "Goods Editor",
      "printable": "FALSE",
      "url": "goodsEditor",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "label": "RM Identity"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.type",
                  "label": "RM Type",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "copyRMFamilyData"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Customer Service | Manager),==,false)",
                  "items": "fetchedData.rmIdentity.data.0.data",
                  "itemText": "name",
                  "itemValue": "name",
                  "validationKey": "type"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.family",
                  "label": "RM Family",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "copyRMCategoryData"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyFilteredRmAliases",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getFilteredRmAliases",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.filteredRmAliases"
                      },
                      "name": "copyFilteredRmAliases"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedRMFamily}}",
                  "items": "fetchedData.selectedRMFamily",
                  "itemText": "name",
                  "itemValue": "name",
                  "validationKey": "family"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.category",
                  "label": "RM Category",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedRMCategory}}",
                  "items": "fetchedData.selectedRMCategory",
                  "itemText": "name",
                  "itemValue": "name",
                  "validationKey": "category"
                }
              ],
              "showIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Customer Service | Manager),||,fn(LOGICAL,fn(CONCAT,',{{formData.type}},'),==,'FG')))"
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.type",
                  "label": "RM Type",
                  "disabled": "FALSE",
                  "items": "[\"FG\"]",
                  "dropdownType": "static",
                  "validationKey": "type"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.family",
                  "label": "RM Family",
                  "disabled": "FALSE",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyFilteredRmAliases",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getFilteredRmAliases",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.filteredRmAliases"
                      },
                      "name": "copyFilteredRmAliases"
                    }
                  ],
                  "items": "fetchedData.productLines.data.0.data",
                  "itemText": "name",
                  "itemValue": "name",
                  "validationKey": "family"
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Customer Service | Manager),||,fn(LOGICAL,fn(CONCAT,',{{formData.type}},'),==,'FG'))"
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "label",
                  "label": "RM General Specs"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.mainSpecification",
                  "label": "Main Specification",
                  "disabled": "FALSE"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedSupplierId",
                  "label": "Supplier",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "getAgentData"
                    },
                    {
                      "executionOrder": 1,
                      "name": "copySupplierData"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.supplierList.data",
                  "itemText": "name",
                  "itemValue": "_id"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedAgent",
                  "label": "Agent",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "copyAgentData"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.agentData.data",
                  "itemText": "name",
                  "itemValue": "_id"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedRmAlias",
                  "label": "RM Alias",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "type": "fnCopyData",
                        "name": "resetRmAlias",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData.rmAlias"
                      },
                      "name": "resetRmAlias"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "type": "fnPushToArray",
                        "name": "copyRmAlias",
                        "arg1Key": "sourceVariable",
                        "arg1Value": "__item",
                        "arg2Key": "destinationVariable",
                        "arg2Value": "formData.rmAlias"
                      },
                      "name": "copyRmAlias"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.filteredRmAliases",
                  "itemText": "alias",
                  "itemValue": "_id"
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.thickness",
                  "label": "Thickness",
                  "unit": "micron",
                  "disabled": "FALSE",
                  "validationKey": "thickness"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.densityUnit",
                  "label": "Type of Density",
                  "disabled": "FALSE",
                  "items": "[{\"text\":\"Volumetric Density\",\"value\":\"KG/m3\"},{\"text\":\"Surface Density\",\"value\":\"GSM\"}]",
                  "itemText": "text",
                  "itemValue": "value",
                  "dropdownType": "static"
                },
                {
                  "type": "input",
                  "variable": "formData.density",
                  "label": "Density",
                  "unit": "{{formData.densityUnit}}",
                  "disabled": "FALSE",
                  "validationKey": "density"
                },
                {
                  "type": "input",
                  "variable": "formData.color",
                  "label": "Color",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Dimensions(in mm)"
                }
              ]
            },
            {
              "name": "8",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.dimensions.length",
                  "label": "Length",
                  "unit": "mm",
                  "disabled": "FALSE",
                  "validationKey": "dimensions.length"
                },
                {
                  "type": "input",
                  "variable": "formData.dimensions.width",
                  "label": "Width",
                  "unit": "mm",
                  "disabled": "FALSE",
                  "validationKey": "dimensions.width"
                },
                {
                  "type": "input",
                  "variable": "formData.dimensions.height",
                  "label": "Height",
                  "unit": "mm",
                  "disabled": "FALSE",
                  "validationKey": "dimensions.height"
                }
              ]
            },
            {
              "name": "9",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.supGrade",
                  "label": "Sup Grade",
                  "disabled": "FALSE",
                  "featureFlag": "451-hide-sup-grade"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.rawMaterialUnit",
                  "label": "Unit",
                  "disabled": "FALSE",
                  "items": "[\"KG\",\"SQM\",\"PCs\",\"LM\"]",
                  "dropdownType": "static",
                  "validationKey": "rawMaterialUnit"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.form",
                  "label": "Form Of Good",
                  "disabled": "FALSE",
                  "items": "[\"roll\",\"sheet\"]",
                  "dropdownType": "static"
                }
              ]
            },
            {
              "name": "10",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.unitWeight",
                  "label": "Unit Weight",
                  "unit": "KG",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.perKgRatio.plA.value",
                  "label": "Pieces Per KG",
                  "unit": "Pcs",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "11",
              "pageItems": [
                {
                  "type": "label",
                  "label": "PSL Only",
                  "showIf": "fn(LOGICAL,'{{formData.family}}',===,'PSL')"
                }
              ]
            },
            {
              "name": "12",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.psl.facestockType",
                  "label": "PSL Facestock Material Type",
                  "disabled": "FALSE",
                  "validationKey": "psl.facestockType"
                },
                {
                  "type": "input",
                  "variable": "formData.psl.linerType",
                  "label": "PSL Liner Material Type",
                  "disabled": "FALSE",
                  "validationKey": "psl.linerType"
                },
                {
                  "type": "input",
                  "variable": "formData.psl.adhesiveType",
                  "label": "PSL Adhesive Material Type",
                  "disabled": "FALSE",
                  "validationKey": "psl.adhesiveType"
                }
              ],
              "showIf": "fn(LOGICAL,'{{formData.family}}',===,'PSL')"
            },
            {
              "name": "13",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.psl.facestockGsm",
                  "label": "PSL Facestock GSM",
                  "unit": "GSM",
                  "disabled": "FALSE",
                  "validationKey": "psl.facestockGsm"
                },
                {
                  "type": "input",
                  "variable": "formData.psl.facestockCaliper",
                  "label": "PSL Facestock Caliper",
                  "unit": "micron",
                  "disabled": "FALSE",
                  "validationKey": "psl.facestockCaliper"
                }
              ],
              "showIf": "fn(LOGICAL,'{{formData.family}}',===,'PSL')"
            },
            {
              "name": "14",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.psl.linerGsm",
                  "label": "PSL Liner GSM",
                  "unit": "GSM",
                  "disabled": "FALSE",
                  "validationKey": "psl.linerGsm"
                },
                {
                  "type": "input",
                  "variable": "formData.psl.linerCaliper",
                  "label": "PSL Liner Caliper",
                  "unit": "micron",
                  "disabled": "FALSE",
                  "validationKey": "psl.linerCaliper"
                }
              ],
              "showIf": "fn(LOGICAL,'{{formData.family}}',===,'PSL')"
            },
            {
              "name": "15",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.notes",
                  "label": "Notes",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "16",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Save",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "saveGood"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Customer Service | Manager),==,false)"
            },
            {
              "name": "17",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Save FG",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "saveFG"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ],
              "showIf": "fn(MATCH_ROLE,Customer Service | Manager)"
            }
          ],
          "type": "genericGroup"
        }
      ]
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getRmIdentityData",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=rm-identity",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.rmIdentity"
        },
        "name": "getRmIdentityData"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getUnitsForDropdown",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=unit_v2",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.units"
        },
        "name": "getUnitsForDropdown"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getProductLines",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=product-lines1",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.productLines"
        },
        "name": "getProductLines"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllSuppliers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/suppliers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.supplierList"
        },
        "name": "getAllSuppliers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Commercial | Purchaser))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getMySuppliers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/suppliers/my",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.supplierList"
        },
        "name": "getMySuppliers",
        "executeIf": "fn(MATCH_ROLE,Commercial | Purchaser)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllRmAliases",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/rm-alias/get",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.rmAliases"
        },
        "name": "getAllRmAliases"
      }
    ],
    "functions": [
      {
        "name": "copyRMFamilyData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject.children",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedRMFamily"
      },
      {
        "name": "copyRMCategoryData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject.children",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedRMCategory"
      },
      {
        "name": "getAgentData",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/agents/get?supplier={{fetchedData.selectedSupplierId}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.agentData"
      },
      {
        "name": "copySupplierData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject",
        "arg2Key": "destinationKey",
        "arg2Value": "formData.supplier"
      },
      {
        "name": "copyAgentData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject",
        "arg2Key": "destinationKey",
        "arg2Value": "formData.agent"
      },
      {
        "name": "saveFG",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/goods/saveFG",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "fnsAfterSubmit",
        "arg3Value": "[{\"name\":\"redirectToFgView\",\"executionOrder\":1}]"
      },
      {
        "name": "redirectToFgView",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/fg-goods-view"
      },
      {
        "name": "saveGood",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/goods/save",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "storeResponse",
        "arg3Value": "TRUE",
        "arg4Key": "fnsAfterSubmit",
        "arg4Value": "[{\"name\":\"redirectToSavedGood\",\"executionOrder\":1}]"
      },
      {
        "name": "redirectToSavedGood",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/goodsEditor/{{__response.data._id}}"
      },
      {
        "name": "getFilteredRmAliases",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.rmAliases.data",
        "arg2Key": "formulaCondition",
        "arg2Value": "fn(LOGICAL,fn(CONCAT,',{{__item.productLine}},'),==,fn(CONCAT,',{{formData.family}},'))"
      }
    ]
  },
  "forRole": "COMMERCIAL_PURCHASER,COMMERCIAL_MANAGER,CUSTOMER_SERVICE_MANAGER",
  "visible": false,
  "routerPriority": 100
}